import '../styles/landing.scss';
import { sendCustomEvent } from './config/analytics';
import { toggleClass } from './utils/toggleClass/toggleClass';

window.Helpers = Object.assign(window.Helpers || {}, {
  sendCustomEvent,
  toggleClass,
});
